import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import styled from '@emotion/styled';
import React, { PureComponent } from 'react';
import { PulseIcon } from '../assets/PulseIcon';
import { blueHoverColor } from '../styles/colors';
import { withMicrophoneMeter } from '../utils/withMicrophoneMeter';

var lastLevel = 0;

var MicVolumeIconDiv = styled.div(function (props) {
  var scaleFactor = 0.9 + props.soundLevel * 1.5;
  scaleFactor = Math.min(1.5, scaleFactor);
  var style = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0.8,
    transform: 'scale(' + scaleFactor + ')'
  };
  if (lastLevel > props.soundLevel) {
    style.transition = 'scale 10.0s linear';
  } else {
    style.transition = 'scale 0.5s ease';
  }
  lastLevel = props.soundLevel;
  return style;
});

var MicMeterDispBase = function (_PureComponent) {
  _inherits(MicMeterDispBase, _PureComponent);

  function MicMeterDispBase() {
    var _temp, _this, _ret;

    _classCallCheck(this, MicMeterDispBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(
        MicVolumeIconDiv,
        { soundLevel: _this.props.soundLevel, disabled: _this.props.disabled },
        React.createElement(PulseIcon, { iconColor: blueHoverColor })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return MicMeterDispBase;
}(PureComponent);

export var MicMeterDisp = withMicrophoneMeter(MicMeterDispBase);